/* co-variant-fallback.js
   Impulse picks the FIRST variant matching a changed option and ignores stock. If that
   variant is sold out, the shopper lands on a dead Add to Cart even when other variants
   in that group are available (e.g. Aero: choosing the Clear frame landed on
   "Clear / Photochromic Light", sold out, while "Clear / Photochromic Dark" had 32).

   This nudges the selection to the first IN-STOCK variant sharing the option the shopper
   just clicked. It only ever acts when the theme's own choice is unavailable, so when
   everything is in stock it does nothing at all.                                        */
(function () {
  'use strict';
  if (window.__coVariantFallback) return;
  window.__coVariantFallback = true;

  var wraps = [].slice.call(document.querySelectorAll('.variant-input-wrap'));
  if (wraps.length < 2) return;           // single-option products can't hit this

  var product = null, busy = false;

  var handle = location.pathname.split('?')[0].replace(/\/$/, '');
  fetch(handle + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) { if (p && p.variants) product = p; })
    .catch(function () { /* leave theme behaviour untouched */ });

  function chosen() {
    return wraps.map(function (w) {
      var c = w.querySelector('input[type=radio]:checked');
      return c ? c.value : null;
    });
  }

  function match(opts) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function pick(wrapIndex, value) {
    var w = wraps[wrapIndex];
    var inputs = [].slice.call(w.querySelectorAll('input[type=radio]'));
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== value) continue;
      if (inputs[i].checked) return;
      var lbl = inputs[i].id ? document.querySelector('label[for="' + inputs[i].id + '"]') : null;
      if (lbl) { lbl.click(); }           // go through the label, as a shopper would
      else { inputs[i].checked = true; inputs[i].dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
  }

  document.addEventListener('change', function (e) {
    if (busy || !product) return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('.variant-input-wrap input[type=radio]')) return;

    var changedIndex = -1;
    for (var i = 0; i < wraps.length; i++) { if (wraps[i].contains(input)) { changedIndex = i; break; } }
    if (changedIndex < 0) return;

    // let the theme finish its own selection first, then check the outcome
    setTimeout(function () {
      if (busy) return;
      var current = match(chosen());
      if (current && current.available) return;   // theme landed somewhere valid

      // first in-stock variant that still honours what the shopper just clicked
      var want = null;
      for (var k = 0; k < product.variants.length; k++) {
        var v = product.variants[k];
        if (v.available && v.options[changedIndex] === input.value) { want = v; break; }
      }
      if (!want) return;                          // genuinely nothing in stock; leave it

      busy = true;
      for (var n = 0; n < wraps.length; n++) {
        if (n === changedIndex) continue;
        pick(n, want.options[n]);
      }
      setTimeout(function () { busy = false; }, 500);
    }, 80);
  }, true);
})();
